<template>
    <div class="input-group">
        <input
            type="search"
            class="form-control rounded"
            placeholder="Suchen ..."
            aria-label="Search"
            aria-describedby="search-addon"
            :value="inputValueLocal"
            @input="handleInput"
        />
        <!-- <button
            type="button"
            class="btn btn-primary"
            ref="c"
            @click="handleSearch"
        >
            Search
        </button> -->
    </div>
</template>

<script>
    export default {
        props: {
            initialValue: {
                type: String,
                default: '',
            },
        },
        emits: ['search'],
        data() {
            return {
                inputValueLocal: this.initialValue,
            };
        },
        methods: {
            handleInput(event) {
                const inputValue = event.target.value;
                this.inputValueLocal = inputValue;
                this.$emit('search', inputValue);
            },
            handleSearch() {
                console.log('Button clicked on child report');
            },
        },
    };
</script>
<style scoped></style>
